module.exports = __webpack_public_path__ + "static/media/Chield_check_light.56cc94fb.svg";